import React, { PropsWithChildren, useEffect, useMemo, useState } from 'react';
import { ArcAuthConfig, ArcAuthProvider, RedirectFail, RedirectSuccess, useArcAuth } from '@arcauth/react-sdk';
import { useNavigate } from 'react-router-dom';
import { configMap, getConfig } from './config/authconfig';
import { encryptAES, decryptAES, decodeURL } from './shared/util/encrypt.decrypt';
import { useDispatch, useSelector } from 'react-redux';
import { setClientConfigData, setClietIdData } from './redux/features/client.configSlice';
import { RootStateType } from './redux/features/rootSlice';
import { getClientConfig } from './config/app';
import { setClientType, setDeviceCode } from './redux/features/deviceConfig.slice';



export const ArcAuthProviderWithRedirectHandling: React.FC<PropsWithChildren> = ({ children }) => {
    const [config, setConfig] = useState<ArcAuthConfig>();
    const [isSet, setIsSet] = useState<boolean>(false);
    const storedClientId = useSelector((state: RootStateType) => state.configStateReducer.clientId);
    // console.log("storedClientId   -",storedClientId);
    // const { isAuthenticated, login } = useArcAuth();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const urlParams = new URLSearchParams(window.location.search);
    const clientId: string = useMemo(() => urlParams.get('client_id') || '', [urlParams.get('client_id')]);
    const code: string = useMemo(() => urlParams.get('code') || '', [urlParams.get('code')]);
    const clientType: string = useMemo(() => urlParams.get('client_type') || '', [urlParams.get('client_type')]);
    // const clientId = decodeURL(encryptedClientId ??'');
    // console.log("clientid  ", clientId, urlParams.get('client_id'));

    useEffect(() => {
        //if (!clientId) return;
        if (clientId && clientId in configMap) {
            // console.log("clientid in useeffect ", clientId)
            setConfig(getConfig(clientId));
            setIsSet(true);
            dispatch(setClietIdData(clientId));
            const clientConfig = getClientConfig(clientId);
            dispatch(setClientConfigData(clientConfig));
            dispatch(setDeviceCode(code));
            dispatch(setClientType(clientType));
            // if (!isAuthenticated) {
            //     login();
            // }
        } else if (storedClientId) {
            // console.log("storedClientId", storedClientId);
            setConfig(getConfig(storedClientId));
            setIsSet(true);
        }
        else {
            // Handle the case where clientId is null or not found in configMap
            //console.error('Client ID not provided or invalid.');
            setIsSet(true);
            navigate("/error");
        }
    }, []);


    useEffect(() => {
        if (storedClientId && !isSet) {
            setIsSet(true)
        }
    }, [storedClientId])


    // Custom handling of success to navigate to the appropriate location via React Router
    const handleRedirectSuccess: RedirectSuccess = () => {
        navigate('/');
    };

    // Custom handle failure
    const handleRedirectFail: RedirectFail = error => {
        console.error(error);
        // window.alert('Something went wrong');
    };

    return (
        <>
            {
                isSet ? <ArcAuthProvider
                    clientID={config?.clientID || ''} // Provide a default value if config.clientID is undefined
                    serverUrl={config?.serverUrl || ''}
                    redirectUri={config?.redirectUri || ''}
                    onRedirectSuccess={handleRedirectSuccess}
                    onRedirectFail={handleRedirectFail}
                >
                    {children}
                </ArcAuthProvider> : null
            }
        </>


    );
}
